const API_BASE_URL =
  "https://expense-tracker-server-gup-abhi-gup-abhis-projects.vercel.app/api";
// const API_BASE_URL = "http://localhost:7000/api";

export default API_BASE_URL;
